// extracted by mini-css-extract-plugin
module.exports = {"animationM":"animationM_animationM__pqOkE"};